import { useEffect } from 'react';

const useLockBodyScroll = (): void => {
  useEffect(() => {
    if (!document) return undefined;

    const { style } = document.body;

    style.setProperty('overflow', 'hidden');

    return () => {
      style.removeProperty('overflow');
    };
  }, []);
};

export default useLockBodyScroll;
